
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import PlayerNavigationVue from "@/components/player/navigation.vue";
import PlayerResourcesNavigationVue from "@/components/player/resources/navigation.vue";
import AppPlayerResourcesSupplementsListIndexVue from "@/views/app/player/resources/supplements/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    PlayerNavigationVue,
    PlayerResourcesNavigationVue,
    AppPlayerResourcesSupplementsListIndexVue,
  },
})
export default class AppPlayerResourcesSupplementsIndexVue extends Vue {}
